import React from "react";
import "./index.scss";
import { Link } from "react-router-dom";
import { Row, Col } from "antd";

function Bottomfooter() {
  const goToTopScreen = () => {
    window.scrollTo(0, 0);
  };

  return (
    <Row className="footer">
      <Col md={10} sm={24}>
        <p>2021 Beam.live. All rights reserved.</p>
      </Col>
      {/* <Col span={2} className="t-center">
        <Button onClick={goToTopScreen}><img alt='1' src="/images/top.png" /></Button>
      </Col> */}
      <Col md={10} sm={24} className="t-right">
        <Link to={"/privacy-policy"}>Privacy Policy</Link>
        <Link to={"/"}>Terms & Conditions</Link>
      </Col>
    </Row>
  );
}

export default Bottomfooter;
